import tippy from 'tippy.js'

const tooltips = document.querySelectorAll('[data-tooltip-rel]')

tooltips.forEach(node => {
  const templateName = node.dataset.tooltipRel
  const templateNode = document.querySelector("[data-tooltip='" + templateName + "']")

  tippy(node, {
    content: templateNode.innerHTML,
    allowHTML: true,
    theme: 'tooltip-info',
    interactive: true,
  })
})
